// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBT05mgQIisXM2qhfFRK1xJDhzNuMCwlpM",
  authDomain: "onlinedo-b7297.firebaseapp.com",
  projectId: "onlinedo-b7297",
  storageBucket: "onlinedo-b7297.firebasestorage.app",
  messagingSenderId: "651739168417",
  appId: "1:651739168417:web:523ebf506b44a0dd01bae0",
  measurementId: "G-EHXJ37WDXQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);